export const RISKS_AND_GUIDED_ACTIONS_KEY = 'RISKS_AND_GUIDED_ACTIONS';